import { createSlice } from "@reduxjs/toolkit";
import { getProjectList, getProjectMemberList } from "../../actions/project-management/ProjectAction";
import { getProjectRole,getProjectManagerList, getProjectType, getSponsorDetails, deleteProjectType,saveProjectType,saveProjectRole,getProjectMethod, deleteProjectRole,saveProjectMethod, deleteProjectMethod,saveSponsor,deleteSponsor} from "../../actions/project-management/ProjectSettingAction";


const initialState={
    //type grid
    loading:false,
    typeList:null,
    error:null,
    success:false,
    //role grid
    loading1:false,
    roleList:null,
    error1:null,
    success1:false,
    //sponsor grid
    loading2:false,
    sponsorList:null,
    error2:null,
    success2:false,
    // add project type
    loading3:false,
    addProjType:null,
    error3:null,
    success3:false,
    //delete project type
    loading11:false,
    deleteProjType:null,
    success11:false,
    error11:false,
    //edit project type
    loading4:false,
    editProjType:null,
    error4:null,
    success4:false,
    //delete project role
    loading8: false,
    success8:false,
    deleteProjRole:null,
    error8:false,
    // add project role
    loading5:false,
    addProjRole:null,
    error5:null,
    success5:false,
    //edit project role
    loading6:false,
    editProjRole:null,
    error6:null,
    success6:false,
    // add project method
    loading7:false,
    methodList:null,
    error7:null,
    success7:false,
    //save project method
    loading9:false,
    addProjMethod: null,
    success9:false,
    error9:false,
    //delete project method
    loading10:false,
    deleteProjMethod: null,
    success10:false,
    error10:false,
    //save sponser list
    loading12:false,
    addSponsorList: null,
    success12:false,
    error12:false,
    //delete sponser list
    loading13:false,
    deleteSponsorList: null,
    success13:false,
    error13:false,
    //get manager list 
    loading14:false,
    projMngList:null,
    success14:true,
    error14:false,
}

const projectSettingSlice = createSlice({
    name:"project-setting",
    initialState,
    extraReducers:(builder)=>{
        builder
        //get project type
        .addCase(getProjectType.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success =false;
        })
        .addCase(getProjectType.fulfilled, (state,{payload}) => {
            state.loading=false;
            state.typeList=payload;
            state.success=true;
            state.error=null;
        })
        .addCase(getProjectType.rejected,(state, {paylaod})=>{
            state.loading=false;
            state.error=paylaod;
            state.success=false;
        })
        // save project type
        .addCase(saveProjectType.pending, (state) => {
            state.loading3 = true;
            state.error3 = null;
            state.success3 =false;
        })
        .addCase(saveProjectType.fulfilled, (state,{payload}) => {
            state.loading3=false;
            state.addProjType=payload;
            state.success3=true;
            state.error3=null;
        })
        .addCase(saveProjectType.rejected,(state, {paylaod})=>{
            state.loading3=false;
            state.error3=paylaod;
            state.success3=false;
        })
         // delete project type
         .addCase(deleteProjectType.pending, (state) => {
            state.loading11 = true;
            state.error11 = null;
            state.success11 =false;
        })
        .addCase(deleteProjectType.fulfilled, (state,{payload}) => {
            state.loading11=false;
            state.deleteProjType=payload;
            state.success11=true;
            state.error11=null;
        })
        .addCase(deleteProjectType.rejected,(state, {paylaod})=>{
            state.loading11=false;
            state.error11=paylaod;
            state.success11=false;
        })
    
        //get project role grid
        .addCase(getProjectRole.pending, (state) => {
            state.loading1 = true;
            state.error1 = null;
            state.success1 =false;
        })
        .addCase(getProjectRole.fulfilled, (state,{payload}) => {
            state.loading1=false;
            state.roleList=payload;
            state.success1=true;
            state.error1=null;
        })
        .addCase(getProjectRole.rejected,(state, {paylaod})=>{
            state.loading1=false;
            state.error1=paylaod;
            state.success1=false;
        })
         // save project role
         .addCase(saveProjectRole.pending, (state) => {
            state.loading5 = true;
            state.error5 = null;
            state.success5 =false;
        })
        .addCase(saveProjectRole.fulfilled, (state,{payload}) => {
            state.loading5=false;
            state.addProjRole=payload;
            state.success5=true;
            state.error5=null;
        })
        .addCase(saveProjectRole.rejected,(state, {paylaod})=>{
            state.loading5=false;
            state.error5=paylaod;
            state.success5=false;
        })
        // delete project role
        .addCase(deleteProjectRole.pending, (state) => {
            state.loading8 = true;
            state.error8 = null;
            state.success8 =false;
        })
        .addCase(deleteProjectRole.fulfilled, (state,{payload}) => {
            state.loading8=false;
            state.deleteProjRole=payload;
            state.success8=true;
            state.error8=null;
        })
        .addCase(deleteProjectRole.rejected,(state, {paylaod})=>{
            state.loading8=false;
            state.error8=paylaod;
            state.success8=false;
        })
         //get sponsor grid
         .addCase(getSponsorDetails.pending, (state) => {
            state.loading2 = true;
            state.error2 = null;
            state.success2 =false;
        })
        .addCase(getSponsorDetails.fulfilled, (state,{payload}) => {
            state.loading2=false;
            state.sponsorList=payload;
            state.success2=true;
            state.error2=null;
        })
        .addCase(getSponsorDetails.rejected,(state, {paylaod})=>{
            state.loading2=false;
            state.error2=paylaod;
            state.success2=false;
        })
        //save sponsor
        .addCase(saveSponsor.pending, (state) => {
            state.loading12 = true;
            state.error12 = null;
            state.success12 =false;
        })
        .addCase(saveSponsor.fulfilled, (state,{payload}) => {
            state.loading12=false;
            state.addSponsorList=payload;
            state.success12=true;
            state.error12=null;
        })
        .addCase(saveSponsor.rejected,(state, {paylaod})=>{
            state.loading12=false;
            state.error12=paylaod;
            state.success12=false;
        })
        //delete sponsor
        .addCase(deleteSponsor.pending, (state) => {
            state.loading13 = true;
            state.error13 = null;
            state.success13 =false;
        })
        .addCase(deleteSponsor.fulfilled, (state,{payload}) => {
            state.loading13=false;
            state.deleteSponsorList=payload;
            state.success13=true;
            state.error13=null;
        })
        .addCase(deleteSponsor.rejected,(state, {paylaod})=>{
            state.loading13=false;
            state.error13=paylaod;
            state.success13=false;
        })
        .addCase(getProjectMethod.pending, (state) => {
            state.loading7 = true;
            state.error7 = null;
            state.success7 =false;
        })
        .addCase(getProjectMethod.fulfilled, (state,{payload}) => {
            state.loading7=false;
            state.methodList=payload;
            state.success7=true;
            state.error7=null;
        })
        .addCase(getProjectMethod.rejected,(state, {paylaod})=>{
            state.loading7=false;
            state.error7=paylaod;
            state.success7=false;
        })
        .addCase(saveProjectMethod.pending, (state) => {
            state.loading9 = true;
            state.error9= null;
            state.success9=false;
        })
        .addCase(saveProjectMethod.fulfilled, (state,{payload}) => {
            state.loading9=false;
            state.addProjMethod=payload;
            state.success9=true;
            state.error9=null;
        })
        .addCase(saveProjectMethod.rejected,(state, {paylaod})=>{
            state.loading9=false;
            state.error9=paylaod;
            state.success9=false;
        })
        .addCase(deleteProjectMethod.pending, (state) => {
            state.loading10 = true;
            state.error10= null;
            state.success10=false;
        })
        .addCase(deleteProjectMethod.fulfilled, (state,{payload}) => {
            state.loading10=false;
            state.deleteProjMethod=payload;
            state.success10=true;
            state.error10=null;
        })
        .addCase(deleteProjectMethod.rejected,(state, {paylaod})=>{
            state.loading10=false;
            state.error10=paylaod;
            state.success10=false;
        })
        //get project manager list
        .addCase(getProjectManagerList.pending, (state) => {
            state.loading14 = true;
            state.error14 = null;
            state.success14 =false;
        })
        .addCase(getProjectManagerList.fulfilled, (state,{payload}) => {
            state.loading14=false;
            state.projMngList=payload;
            state.success14=true;
            state.error14=null;
        })
        .addCase(getProjectManagerList.rejected,(state, {paylaod})=>{
            state.loading14=false;
            state.error14=paylaod;
            state.success14=false;
        })
    }
});

export default projectSettingSlice.reducer;